/** An eclipse's mark: the sun's rays and rim round the moon's dark face, or the moon reddened in the
 * earth's shadow, a sliver of it still lit. */
/** The sun's rays, eight round it. */
const RAYS = Array.from({ length: 8 }, (_, ray) => {
  const [x, y] = [Math.cos((ray * Math.PI) / 4), Math.sin((ray * Math.PI) / 4)];
  return [12 + 8.4 * x, 12 + 8.4 * y, 12 + 11 * x, 12 + 11 * y] as const;
});

export function EclipseIcon({ body, size = 16 }: { body: 'sun' | 'moon'; size?: number }) {
  return (
    <svg
      className={`eclipse-icon eclipse-${body}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      {body === 'sun' ? (
        <>
          <g stroke="#f59e0b" strokeWidth="2" strokeLinecap="round">
            {RAYS.map(([x1, y1, x2, y2]) => (
              <line key={`${String(x1)} ${String(y1)}`} x1={x1} y1={y1} x2={x2} y2={y2} />
            ))}
          </g>
          <circle cx="12" cy="12" r="6.6" fill="#f59e0b" />
          <circle cx="12.6" cy="11.6" r="5.6" fill="#1f2937" />
        </>
      ) : (
        <>
          <circle cx="12" cy="12" r="10" fill="#fde68a" />
          <circle cx="10.6" cy="12.6" r="9.4" fill="#b45309" />
        </>
      )}
    </svg>
  );
}
